// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type GetMinimalEmployeeQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GetMinimalEmployeeQuery = { __typename?: 'Query' } & {
  employee: Types.Maybe<
    { __typename?: 'Employee' } & Pick<Types.Employee, 'id'> & {
        generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
          Types.EmployeeGeneralInformation,
          'preferredFullName' | 'legalFullName' | 'hiredDate'
        >;
        currentMainContract: Types.Maybe<
          { __typename?: 'EmployeeContract' } & Pick<Types.EmployeeContract, 'companyId'>
        >;
      }
  >;
};

export const GetMinimalEmployeeDocument = /*#__PURE__*/ gql`
    query getMinimalEmployee($id: ID!) {
  employee(id: $id) {
    id
    generalInformation {
      preferredFullName
      legalFullName
      hiredDate
    }
    currentMainContract {
      companyId
    }
  }
}
    `;

/**
 * __useGetMinimalEmployeeQuery__
 *
 * To run a query within a React component, call `useGetMinimalEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMinimalEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMinimalEmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMinimalEmployeeQuery(
  baseOptions: Apollo.QueryHookOptions<GetMinimalEmployeeQuery, GetMinimalEmployeeQueryVariables> &
    ({ variables: GetMinimalEmployeeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMinimalEmployeeQuery, GetMinimalEmployeeQueryVariables>(
    GetMinimalEmployeeDocument,
    options,
  );
}
export function useGetMinimalEmployeeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMinimalEmployeeQuery, GetMinimalEmployeeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMinimalEmployeeQuery, GetMinimalEmployeeQueryVariables>(
    GetMinimalEmployeeDocument,
    options,
  );
}
// @ts-expect-error
export function useGetMinimalEmployeeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetMinimalEmployeeQuery, GetMinimalEmployeeQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetMinimalEmployeeQuery, GetMinimalEmployeeQueryVariables>;
export function useGetMinimalEmployeeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMinimalEmployeeQuery, GetMinimalEmployeeQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetMinimalEmployeeQuery | undefined, GetMinimalEmployeeQueryVariables>;
export function useGetMinimalEmployeeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMinimalEmployeeQuery, GetMinimalEmployeeQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMinimalEmployeeQuery, GetMinimalEmployeeQueryVariables>(
    GetMinimalEmployeeDocument,
    options,
  );
}
export type GetMinimalEmployeeQueryHookResult = ReturnType<typeof useGetMinimalEmployeeQuery>;
export type GetMinimalEmployeeLazyQueryHookResult = ReturnType<typeof useGetMinimalEmployeeLazyQuery>;
export type GetMinimalEmployeeSuspenseQueryHookResult = ReturnType<typeof useGetMinimalEmployeeSuspenseQuery>;
